<template>
  <div class="wrap-content">
    <!-- <p class="title-logo">MetalX</p> -->
    <img src="../assets/abi-vertical.png" alt="" class="img-title" />
    <div class="hello">
      <div class="content-left">
        <p class="brand">Konfirmasi Pialang</p>
      </div>
      <div class="content-right">
        <p>Wakil Pialang kami akan menghubungi anda untuk proses verifikasi lebih lanjut</p>
        <router-link to="/login">
          <button class="btn-primer" @click="backToHome">Back to Home</button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      status: "",
      form: {
        password: "",
        confirm_password: "",
      },
      token: "",
      isLoading: false,
    };
  },
  methods: {
    resetPassword() {},
  },
};
</script>

<style scoped>
label {
  display: block;
}
.wrap-content {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: rgba(197, 151, 51, 0.4);
}

.title-logo {
  position: relative;
  top: -30px;
  font-size: 45px;
  font-weight: bold;
  color: #1e354a;
}

.img-title {
  height: 98px;
  margin-bottom: 40px;
}

.hello {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.content-left {
  background: #1e354a;
  color: white;
  width: 35rem;
  padding: 10px 15px;
  border-radius: 5px 5px 0 0;
  text-align: center;
}

.content-right {
  background: white;
  border-radius: 5px;
  padding: 40px 45px;
  box-shadow: 0px 8px 20px 0px rgb(0 0 0 / 15%);
  font-weight: bold;
  width: 55%;
}

.content-right p {
  font-size: 30px;
  margin-bottom: 3rem;
}

.form-input {
  width: 540px;
  height: 50px;
}

.brand {
  font-size: 25px;
  font-weight: bold;
  margin: 0 0;
}

.notice {
  width: 435px;
  height: 17px;
  font-size: 12px;
  font-weight: bold;
  margin: -19px 0 35px 15px;
  color: rgba(112, 112, 112, 0.7);
}

@media (min-width: 720px) and (max-width: 1024px) {
  .hello {
    flex-wrap: wrap;
  }

  .content-left {
    text-align: center;
  }

  .content-right {
    margin: -100px 0 0 0;
  }

  .btn-primer {
    width: 225px;
    display: block;
    margin: 40px auto;
  }

  .have-account {
    text-align: center;
  }
}
</style>
